import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";

import imgDashboard from "../../Assets/Projects/bcw/Dashboards.png";
import imgGaugeTemplates from "../../Assets/Projects/bcw/Gauges.png";
import imgAddGauge from "../../Assets/Projects/bcw/gauges2.png";

import imgProjectDetail from "../../Assets/Projects/bcw/projectdetail.png";
import imgWorkPlan from "../../Assets/Projects/bcw/workplan.png";
import imgAttachments from "../../Assets/Projects/bcw/attachments.png";
import imgTimeReview from "../../Assets/Projects/bcw/timereview.png";

import imgSpreadsheet from "../../Assets/Projects/bcw/spreadsheet.png";
import imgQuickView from "../../Assets/Projects/bcw/quickview.png";

import imgSwimlane from "../../Assets/Projects/bcw/swimlane.png";
import imgGantt from "../../Assets/Projects/bcw/gantt.png";
import imgKanban from "../../Assets/Projects/bcw/kanban.png";
import imgKanbanReview from "../../Assets/Projects/bcw/kanbanreview.png";

import imgScheduling from "../../Assets/Projects/bcw/scheduling.png";
import imgScheduleColors from "../../Assets/Projects/bcw/customschedulecolors.png";

import imgReviewMode from "../../Assets/Projects/bcw/reivewmode.png";

import imgAIReport from "../../Assets/Projects/bcw/aireportgenerator.png";
import imgAIConfig from "../../Assets/Projects/bcw/aiconfig.png";

import imgAdmin from "../../Assets/Projects/bcw/admin.png";
import imgAuditLog from "../../Assets/Projects/bcw/auditlog.png";
import imgScheduledReports from "../../Assets/Projects/bcw/scheduledreports.png";

const ss = { borderRadius: "8px", width: "100%", marginBottom: "10px" };
const label = { color: "rgb(155 126 172)", marginBottom: "6px", marginTop: "14px" };

function Section({ title, children }) {
  return (
    <>
      <Row style={{ justifyContent: "center", paddingTop: "30px" }}>
        <Col md={10}>
          <h4 style={{ color: "white", borderBottom: "1px solid rgb(100 60 140)", paddingBottom: "8px" }}>
            {title}
          </h4>
        </Col>
      </Row>
      {children}
    </>
  );
}

function Shot({ src, caption, md = 10 }) {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "6px" }}>
      <Col md={md}>
        <p style={label}>{caption}</p>
        <img src={src} alt={caption} className="img-fluid" style={ss} />
      </Col>
    </Row>
  );
}

function ShotPair({ left, right, captionL, captionR }) {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "6px" }}>
      <Col md={5}>
        <p style={label}>{captionL}</p>
        <img src={left} alt={captionL} className="img-fluid" style={ss} />
      </Col>
      <Col md={5}>
        <p style={label}>{captionR}</p>
        <img src={right} alt={captionR} className="img-fluid" style={ss} />
      </Col>
    </Row>
  );
}

function BetterConnectWise() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong className="purple">BetterConnectWise</strong>
        </h1>
        <p style={{ color: "white", textAlign: "center" }}>
          ConnectWise is powerful, but its native interface leaves a lot to be desired. BetterConnectWise is a standalone, API-powered project management dashboard I built to give our team a better way to see, manage, and act on the work in front of them.
        </p>

        <Row style={{ justifyContent: "center", paddingTop: "20px", paddingBottom: "10px", color: "white" }}>
          <Col md={10} className="project-card">
            <h4>What It Does</h4>
            <br />
            <p style={{ color: "white", textAlign: "left" }}>
              <ul>
                <li>Pulls live project data from the ConnectWise API and presents it in a fully custom interface.</li>
                <li><b>Dashboard</b> - Customizable gauges and status widgets, team workload at a glance, project health tracking, stale project alerts, and a real-time project tracker with recent activity feeds.</li>
                <li><b>Spreadsheet View</b> - Full project list with inline editing, budget tracking, hours remaining, and last activity. Supports sorting, filtering, and column configuration.</li>
                <li><b>Swimlane</b> - Workload view by project lead, organized into lifecycle stages (Planning - Design - Implementation - Testing - Handoff). Drag cards between stages to update status.</li>
                <li><b>Gantt Chart</b> - Full timeline view across all active projects, grouped by category with color-coded health indicators.</li>
                <li><b>Kanban Board</b> - Projects organized by status (New, In Progress, Waiting On, Wrap-Up, Onboarding, Dormant) with budget and progress at a glance.</li>
                <li><b>Schedule</b> - Calendar view for engineer scheduling with ticket drag-and-drop, color-coded entry types, and week/month toggle.</li>
                <li><b>Weekly Review</b> - Structured project review workflow with action item tracking and review completion progress.</li>
                <li><b>AI Integration</b> - Copilot Studio agents generate project summaries, write activity reports, and suggest milestones. All AI calls are logged and auditable.</li>
                <li><b>Admin Panel</b> - AI agent configuration, scheduled email reports, audit log, API log, and permission management.</li>
              </ul>
            </p>

            <h4>Built With</h4>
            <br />
            <p style={{ color: "white", textAlign: "left" }}>
              <ul>
                <li>ConnectWise REST API for live data sync</li>
                <li>Microsoft Copilot Studio for AI agent integration</li>
                <li>React frontend with custom component architecture</li>
                <li>Targeted at Azure Static Web App deployment</li>
              </ul>
            </p>

            <h4>Why I Built It</h4>
            <br />
            <p style={{ color: "white", textAlign: "left" }}>
              Our team was spending too much time working around the ConnectWise UI rather than in it. I wanted a purpose-built interface that matched the way our team actually works - with the right views, the right alerts, and AI assistance where it actually helps. This project is a direct product of that goal, and it continues to evolve as we find new things to improve.
            </p>
          </Col>
        </Row>

        <Section title="Dashboard">
          <Shot src={imgDashboard} caption="Main dashboard - customizable gauges, team workload, project tracker, and stale project alerts" />
          <ShotPair
            left={imgGaugeTemplates} captionL="Dashboard templates - role-specific starting points (Project Manager, Project Engineer, Executive, Finance)"
            right={imgAddGauge} captionR="Add Gauge panel - full library of available widgets organized by category"
          />
        </Section>

        <Section title="Spreadsheet View">
          <Shot src={imgSpreadsheet} caption="Full project list with status, budget, hours, progress, and due dates - sortable and filterable" />
          <Shot src={imgQuickView} caption="Quick view panel - open any project inline without leaving the spreadsheet" />
        </Section>

        <Section title="Project Detail">
          <Shot src={imgProjectDetail} caption="Project home - status, milestones, sign-off tracking, phases, and recent activity" />
          <Shot src={imgWorkPlan} caption="Work plan tab - WBS ticket list with status, priority, type, assignee, and budget tracking" />
          <ShotPair
            left={imgAttachments} captionL="Attachments tab - file management with inline PDF preview"
            right={imgTimeReview} captionR="Time tab - time entry log with member, notes, hours, and billing breakdown"
          />
        </Section>

        <Section title="Swimlane">
          <Shot src={imgSwimlane} caption="Swimlane view - workload organized by project lead across lifecycle stages (Planning, Design, Implementation, Testing, Handoff)" />
        </Section>

        <Section title="Gantt Chart">
          <Shot src={imgGantt} caption="Gantt chart - full portfolio timeline grouped by category with color-coded health status" />
        </Section>

        <Section title="Kanban Board">
          <Shot src={imgKanban} caption="Kanban board - projects by lifecycle status with budget and progress per card" />
          <Shot src={imgKanbanReview} caption="Kanban review mode - action item panel open alongside the board for weekly review workflow" />
        </Section>

        <Section title="Schedule">
          <Shot src={imgScheduling} caption="Schedule view - engineer calendar with color-coded entry types, ticket drag-and-drop, and unscheduled project queue" />
          <Row style={{ justifyContent: "center", paddingBottom: "6px" }}>
            <Col md={4}>
              <p style={label}>Entry type color customization</p>
              <img src={imgScheduleColors} alt="Schedule color settings" className="img-fluid" style={ss} />
            </Col>
          </Row>
        </Section>

        <Section title="Weekly Review">
          <Shot src={imgReviewMode} caption="Review mode - structured weekly project review with action items, completion tracking, and open task management" />
        </Section>

        <Section title="AI Features">
          <Shot src={imgAIReport} caption="AI report generator - timesheet and client-facing reports with AI summary, date range, and shareable link options" />
          <Shot src={imgAIConfig} caption="AI configuration - Copilot Studio agent wiring for AI Summary, Milestone Generator, and Portfolio Briefing" />
        </Section>

        <Section title="Admin">
          <Shot src={imgAdmin} caption="Admin home - operational visibility hub for configurations, logs, AI settings, and reporting" />
          <ShotPair
            left={imgAuditLog} captionL="Audit log - every CW write and AI call tied to user, module, and outcome"
            right={imgScheduledReports} captionR="Scheduled reports - automatic portfolio summary emails on a daily or weekly schedule"
          />
        </Section>

        <Particle />
      </Container>
    </Container>
  );
}

export default BetterConnectWise;
